import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PermissionDto, PermissionGroupDto } from './roles.service';

export interface AllPermissionsResponseDto {
  groups: PermissionGroupDto[];
  totalPermissions: number;
}

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  private readonly apiUrl = `${environment.apiUrl}/permissions`;

  constructor(private http: HttpClient) {}

  /**
   * Obtiene todos los permisos del sistema
   */
  getAllPermissions(): Observable<PermissionDto[]> {
    return this.http.get<PermissionDto[]>(this.apiUrl);
  }

  /**
   * Obtiene todos los permisos agrupados por módulo
   */
  getAllPermissionsGrouped(): Observable<AllPermissionsResponseDto> {
    return this.http.get<AllPermissionsResponseDto>(`${this.apiUrl}/grouped`);
  }

  /**
   * Obtiene permisos por módulo
   */
  getPermissionsByModule(module: string): Observable<PermissionDto[]> {
    return this.http.get<PermissionDto[]>(`${this.apiUrl}/by-module/${module}`);
  }

  /**
   * Obtiene un permiso por su código
   */
  getPermissionByCode(code: string): Observable<PermissionDto> {
    return this.http.get<PermissionDto>(`${this.apiUrl}/by-code/${code}`);
  }
}

